<template>
  <div class=" md:mx-auto text-left mt-24 pt-24 px-24 justify-self-start
  min-h-screen bg-gray-100 w-5/6 mx-auto top-0">
    <lesson-summary :lesson="lesson" />
    <div class="text-center mt-16 w-full uppercase text-md text-red-700">
      {{ $t('payments.authFailed') }}
    </div>
    <div class="flex flex-col text-center items-center mt-2">
        <router-link class="rounded bg-beige-academy-300 w-1/2 p-3 m-5 uppercase font-semibold
          hover:text-white hover:bg-beige-academy-500 transform hover:scale-105"
          :to="'/payment?booking='+lesson.booking_id">
            {{ $t('payments.update') }}
        </router-link>
      </div>
  </div>
</template>

<script>
import { getLesson } from '@/services/LessonService';
import LessonSummary from '../components/payment/LessonSummary.vue';

export default {
  data() {
    return {
      lesson: {},
    };
  },

  components: {
    LessonSummary,
  },

  created() {
    getLesson(this.$route.query.lesson).then(({ data }) => {
      this.lesson = data;
    });
  },
};
</script>
